import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { get } from 'lodash-es';
import {
  Control,
  Controller,
  FieldErrors,
  FieldPath,
  FieldPathValue,
  FieldValues,
} from 'react-hook-form';

interface CheckBoxFormFieldProps<TFieldValues extends FieldValues = FieldValues> {
  checkboxSx?: SxProps<Theme>;
  control: Control<TFieldValues>;
  dataUi?: string;
  disabled?: boolean;
  errors?: FieldErrors<TFieldValues>;
  hideLabel?: boolean;
  isRequired?: boolean;
  label?: string;
  name: string;
  sx?: SxProps<Theme>; // Style
  value?: boolean;
}
export const CheckBoxFormField = <TFieldValues extends FieldValues = FieldValues>({
  checkboxSx,
  control,
  disabled = false,
  errors,
  hideLabel = false,
  isRequired = false,
  label,
  name,
  sx,
  value = false,
  dataUi,
}: CheckBoxFormFieldProps<TFieldValues>) => {
  return (
    <FormControl error={Boolean(get(errors, name))} sx={{ ...sx }}>
      <FormControlLabel
        control={
          <Controller
            rules={{ required: isRequired }}
            name={name as FieldPath<TFieldValues>}
            control={control}
            defaultValue={value as FieldPathValue<TFieldValues, FieldPath<TFieldValues>>}
            render={({ field: props }) => (
              <Checkbox
                {...props}
                checked={Boolean(props.value)}
                disabled={disabled}
                onChange={(e) => props.onChange(e.target.checked)}
                slotProps={{ input: { 'aria-label': hideLabel ? label : undefined } }}
                sx={checkboxSx}
                {...(dataUi && { 'data-ui': dataUi })}
              />
            )}
          />
        }
        label={hideLabel ? '' : label || ''}
        sx={hideLabel ? { mx: 0 } : undefined}
      />
    </FormControl>
  );
};
